export default __webpack_public_path__ + "static/media/logo.41de4394.svg";